import React from 'react';
import style from './Spinner.module.scss'

const Spinner = () => {
    return (
        <div className={style.loader}/>
    );
};

export default Spinner;